import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import {
	add,
	photo,
	festivalName,
	festivalMonthsQn,
	celebrateReligion,
	festivalAttribute,
	festivalMonths,
	festAttribute,
	wardQuestion,
	address,
	cancel,
	selectedLanguage,
	ward,
} from "../data/institute";
import ImageUploader from "../components/ImageUploader";
import FormFooterButtons from "../components/FormFooterButtons";
import { Card } from "react-bootstrap";
import { GetUUID } from "../data/helpers/RandomNumGenerator";

const initData = {
	name: "",
	ward: "",
	address: "",
	name: "",
	festivalMonths: "",
	festivalAttribute: "",
	celebrateReligion: "",
	uniqueIdentifier: GetUUID(),
};

const Festival = (props) => (
	<div>
		<Formik
			enableReinitialize
			initialValues={props.data ? props.data : initData}
			validate={(values) => {
				const errors = {};
				// if (!values.name) {
				//     errors.name = 'Required';
				// }
				// if (!values.ward) {
				//     errors.ward = 'Required';
				// }
				// if (!values.infrastructure) {
				//     errors.infrastructure = 'Required';
				// }
				// if (!values.haatbazaarName) {
				//     errors.haatbazaarName = 'Required';
				// }
				// if (!values.haatrWard) {
				//     errors.haatrWard = 'Required';
				// }
				// if (!values.haatMarket) {
				//     errors.haatMarket = 'Required';
				// }
				// if (!values.haatInfra) {
				//     errors.haatInfra = 'Required';
				// }
				// if (!values.haatType) {
				//     errors.haatType = 'Required';
				// }
				return errors;
			}}
			onSubmit={(values, { setSubmitting }) => {
				console.log(values);
				setTimeout(() => {
					props.submit(values);
					setSubmitting(false);
				}, 400);
			}}
		>
			{({
				values,
				touched,
				errors,
				dirty,
				isSubmitting,
				handleChange,
				handleBlur,
				handleSubmit,
				handleReset,
			}) => (
				<>
					<form className="form survey-form" onSubmit={handleSubmit}>
						<Card>
							<Card.Body>
								<div className="form-group row">
									<div className="col-md-6">
										<label className="form-control-label">
											{wardQuestion[selectedLanguage]}
										</label>
										<select
											className="form-control"
											id="ward"
											name="ward"
											onChange={handleChange}
											value={values.ward ? values.ward : "selectOne"}
										>
											<option value="selectOne" disabled>
												कुनै एक छान्नुहोस्
											</option>
											{ward.map((woda) => (
												<option value={woda.value}>
													{woda[selectedLanguage]}
												</option>
											))}
										</select>
										<ErrorMessage
											className="invalid-feedback"
											name="ward"
											component="div"
										/>
									</div>
									<div className="col-md-6">
										<label className="form-control-label">
											{festivalName[selectedLanguage]}
										</label>
										<input
											type="text"
											className="form-control"
											placeholder={festivalName[selectedLanguage]}
											name="festivalName"
											onChange={handleChange}
										/>
										<ErrorMessage
											class="invalid-feedback"
											name="festivalName"
											component="div"
										/>
									</div>
								</div>
								<div className="form-group row">
									<div className="col-md-6">
										<label className="form-control-label">
											{festivalMonthsQn[selectedLanguage]}
										</label>
										<select
											className="form-control"
											id="festivalMonths"
											name="festivalMonths"
											onChange={handleChange}
											value={values.festivalMonths}
											multiple={true}
										>
											{festivalMonths.map((months) => (
												<option value={months.value}>
													{months[selectedLanguage]}
												</option>
											))}
										</select>
										<ErrorMessage
											className="invalid-feedback"
											name="festivalMonths"
											component="div"
										/>
									</div>
									<div className="col-md-6">
										<label className="form-control-label">
											{address[selectedLanguage]}
										</label>
										<input
											type="text"
											className="form-control"
											placeholder=""
											name="address"
											onChange={handleChange}
											value={values.address}
										/>
										<ErrorMessage
											className="invalid-feedback"
											name="address"
											component="div"
										/>
									</div>
									<div className="col-md-6">
										<label className="form-control-label">
											{celebrateReligion[selectedLanguage]}
										</label>
										<textarea
											type="text"
											class="form-control"
											id="exampleTextarea"
											rows="3"
											name="celebrateReligion"
											onChange={handleChange}
											value={values.celebrateReligion}
										></textarea>
										<ErrorMessage
											className="invalid-feedback"
											name="celebrateReligion"
											component="div"
										/>
									</div>
									<div className="col-md-6">
										<label className="form-control-label">
											{festivalAttribute[selectedLanguage]}
										</label>
										<input
											type="text"
											className="form-control"
											placeholder=""
											name="festivalAttribute"
											onChange={handleChange}
											value={values.festivalAttribute}
										/>
										<ErrorMessage
											className="invalid-feedback"
											name="festivalAttribute"
											component="div"
										/>
									</div>
									<div className="col-md-6">
										<label>{photo[selectedLanguage]}</label>
										<ImageUploader fileListContent={props.fileListContent} />
									</div>
								</div>
								<div className="card-footer text-right">
									<FormFooterButtons />
								</div>
							</Card.Body>
						</Card>
					</form>
				</>
			)}
		</Formik>
	</div>
);

export default Festival;
